import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";
import "@fontsource/manrope/800.css";
import App from "./App";
import "./styles.css";

const CLIENT_BUILD = "2026-07-20.9";

function syncMobileViewport() {
  const mobileLayout = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    || window.matchMedia("(pointer: coarse)").matches;
  document.documentElement.dataset.mobileLayout = String(mobileLayout);
  if (!mobileLayout) return;

  const widths = [window.innerWidth, window.screen.width, window.screen.availWidth, window.visualViewport?.width]
    .filter((width): width is number => typeof width === "number" && width > 0);
  const visibleWidth = Math.max(280, Math.floor(Math.min(...widths) - 16));
  document.documentElement.style.setProperty("--app-viewport-width", `${visibleWidth}px`);
}

syncMobileViewport();
window.addEventListener("resize", syncMobileViewport);
window.addEventListener("orientationchange", syncMobileViewport);
window.visualViewport?.addEventListener("resize", syncMobileViewport);

async function refreshWhenBuildChanges() {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
    const version = await response.json() as { build?: string };
    if (version.build && version.build !== CLIENT_BUILD) window.location.reload();
  } catch {
    // A temporary network failure should not interrupt the current chat.
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).then((registration) => registration.update());
  });
}

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    syncMobileViewport();
    void refreshWhenBuildChanges();
  }
});
window.setInterval(() => void refreshWhenBuildChanges(), 60_000);
